<div class="position-relative">
  <img class="cog1" src="assets/images/404_cog.png" />
  <img class="cog2" src="assets/images/404_cog.png" />
  <img src="assets/images/404_laptop.png" class="d-block mx-auto mt-4" style="max-width: 400px; min-width: 320px;" />
  <h1 class="text-center text-muted">
    Page not found...
  </h1>
</div>
